import { useMemo } from "react";
import type { ProtoMatchGoals } from "@catbento/shared";
import { readSnapshot } from "../data/snapshot.js";
import { getMatchGoalsMap } from "../data/matches.js";

// Phase 02 seam: the goal-by-goal timelines, keyed by matchId — the Matches
// widget's Team-Goals overlay. Returns the whole map so the renderer indexes it
// by each appearance's matchId (a hook can't be called per match). At the Part-2
// cutover this hook fetches GET /match-goals and adapts to the same shape.
export function useMatchGoals(): Record<string, ProtoMatchGoals> {
  return useMemo(() => getMatchGoalsMap(readSnapshot()), []);
}
